<template>
  <b-modal
    id="parcela-modal"
    ref="modal"
    hide-header
    hide-footer
    centered
    body-class="p-0 overflow-hidden"
    @show="onShow"
    @hidden="onHidden"
  >
    <!-- Custom Premium Header -->
    <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
      <div class="header-icon-wrapper-modal mr-3 bg-white-100">
        <i class="fa fa-calendar text-primary"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">Alterar Parcela</h5>
        <small class="text-white opacity-75">Ajuste o vencimento e valores da duplicata</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs.modal.hide()">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div>

    <div class="p-4">
      <b-form v-if="local">
        <div class="modal-section-title mb-3">
          <i class="fa fa-info-circle mr-2 text-primary"></i> Dados da Duplicata
        </div>

        <b-row>
          <b-col md="6">
            <b-form-group label="Número da Duplicata" label-class="modal-label-premium">
              <b-form-input v-model="local.TX_NUMERO" readonly class="rounded-pill bg-light border-0 shadow-xs" />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="* Data de Vencimento" label-class="modal-label-premium">
              <CecInputData v-model="local.DT_VENCIMENTO" input-class="rounded-pill shadow-xs" />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4">
            <b-form-group label="Valor Total" label-class="modal-label-premium">
              <vue-autonumeric
                v-model="local.VL_TOTAL"
                :options="autonumericOptions"
                class="form-control rounded-pill shadow-xs text-right font-weight-bold text-primary"
              />
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Desconto" label-class="modal-label-premium">
              <vue-autonumeric
                v-model="local.VL_DESCONTO"
                :options="autonumericOptions"
                class="form-control rounded-pill shadow-xs text-right text-danger"
              />
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Valor Líquido" label-class="modal-label-premium">
              <vue-autonumeric
                :value="valorDescontado"
                :options="autonumericOptions"
                class="form-control rounded-pill bg-light border-0 shadow-xs text-right font-weight-bold"
                readonly
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Custom Footer -->
        <div class="modal-footer-premium bg-light border-top p-3 d-flex justify-content-end mx-n4 mb-n4 mt-4">
          <b-button variant="light" @click="$refs.modal.hide()" class="mr-2 rounded-pill px-4 shadow-sm font-weight-bold">
            <i class="fa fa-times mr-1"></i> Cancelar
          </b-button>
          <b-button variant="primary" @click="handleOk" class="rounded-pill px-4 shadow-sm font-weight-bold">
            <i class="fa fa-check mr-1"></i> Gravar Alterações
          </b-button>
        </div>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import VueAutonumeric from 'vue-autonumeric'
import CecInputData from '@/components/Cec/CecInputData.vue'

export default {
  name: 'ParcelaModal',
  components: { VueAutonumeric, CecInputData },
  props: {
    parcela: { type: Object, default: null }
  },
  data() {
    return {
      local: null,
      autonumericOptions: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalPlaces: 2,
        currencySymbol: 'R$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0'
      }
    }
  },
  computed: {
    valorDescontado() {
      if (!this.local) return 0
      const total = Number(this.local.VL_TOTAL || 0)
      const desconto = Number(this.local.VL_DESCONTO || 0)
      return total - desconto
    }
  },
  methods: {
    mostrar() {
      this.$bvModal.show('parcela-modal')
    },
    
    onShow() {
      if (this.parcela) {
        this.local = {
          ID: this.parcela.ID,
          ID_NFE: this.parcela.ID_NFE,
          NR_PARCELA: this.parcela.NR_PARCELA || 0,
          TX_NUMERO: this.parcela.TX_NUMERO || '',
          DT_VENCIMENTO: this.formatDateForInput(this.parcela.DT_VENCIMENTO),
          VL_TOTAL: Number(this.parcela.VL_TOTAL || 0),
          VL_DESCONTO: Number(this.parcela.VL_DESCONTO || 0),
          VL_DESCONTADO: Number(this.parcela.VL_DESCONTADO || 0)
        }
      }
    },

    onHidden() {
      this.local = null
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      
      if (!this.validar()) {
        return
      }

      // Atualizar VL_DESCONTADO antes de emitir
      this.local.VL_DESCONTADO = this.valorDescontado

      this.$emit('salvar', this.local)
      this.$nextTick(() => {
        this.$refs.modal.hide()
      })
    },

    validar() {
      if (!this.local.DT_VENCIMENTO) {
        this.toast('Informe a data de vencimento', 'warning')
        return false
      }

      if (this.local.VL_TOTAL <= 0) {
        this.toast('Valor total deve ser maior que zero', 'warning')
        return false
      }

      if (this.local.VL_DESCONTO < 0) {
        this.toast('Desconto não pode ser negativo', 'warning')
        return false
      }

      return true
    },

    formatDateForInput(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    toast(msg, variant = 'info') {
      this.$bvToast && this.$bvToast.toast(msg, {
        title: 'Parcela',
        variant,
        autoHideDelay: 3500,
        solid: true
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/ParcelaModal.vue